/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetCustomerPrefixList$Params {
  customer_id: string;
}

export function getCustomerPrefixList(
  http: HttpClient,
  rootUrl: string,
  params: GetCustomerPrefixList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerPrefixList.PATH, "get");
  if (params) {
    rb.path("customer_id", params.customer_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    }),
  );
}

getCustomerPrefixList.PATH = "/dashboard/cbw/prefix/{customer_id}";
